import React, { useEffect, useState } from 'react';
import { getRequest, deleteRequest, putRequest } from 'apis/ApiInstence';
import AdminTable from 'common/AdminTable';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { FaTrash, FaFilePdf } from 'react-icons/fa';

const ListEventFiles = () => {
    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchFiles = async () => {
        try {
            setLoading(true);
            const res = await getRequest('event-files');
            setFiles(res?.data || []);
        } catch (err) {
            console.error('Failed to fetch files:', err);
            toast.error("Failed to load files list.");
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this file?")) {
            try {
                await deleteRequest(`event-files/${id}`);
                toast.success("File deleted successfully!");
                fetchFiles(); // Refresh list
            } catch (err) {
                console.error(err);
                toast.error("Failed to delete file.");
            }
        }
    };

    const handleToggleStatus = async (file) => {
        try {
            await putRequest(`event-files/${file.id}`, { is_active: !file.is_active });
            toast.success("File status updated!");
            fetchFiles();
        } catch (err) {
            console.error(err);
            toast.error("Failed to update status.");
        }
    };

    const tableHeaders = [
        {
            Header: 'ID',
            accessor: 'id',
        },
        {
            Header: 'Category',
            accessor: 'event_category',
            Cell: ({ row }) => (
                <div className="font-weight-bold text-primary">
                    {row.original.event_category ? row.original.event_category.name : 'Unknown'}
                </div>
            )
        },
        {
            Header: 'File Title',
            accessor: 'title',
            Cell: ({ row }) => (
                <div className="text-left font-weight-bold">
                    {row.original.title}
                </div>
            )
        },
        {
            Header: 'File',
            accessor: 'file_url',
            Cell: ({ row }) => {
                const fileUrl = `${process.env.REACT_APP_IMG_URL || 'http://localhost:8080'}/events/${row.original.file_url}`;
                return (
                    <a href={fileUrl} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-danger">
                        <FaFilePdf className="mr-1" /> View PDF
                    </a>
                )
            }
        },
        {
            Header: 'Status',
            accessor: 'is_active',
            Cell: ({ row }) => (
                <button 
                    className={`btn btn-sm ${row.original.is_active ? 'btn-success' : 'btn-secondary'}`}
                    onClick={() => handleToggleStatus(row.original)}
                    style={{ width: '80px', borderRadius: '20px' }}
                >
                    {row.original.is_active ? 'Active' : 'Inactive'}
                </button>
            )
        },
        {
            Header: 'Actions',
            accessor: 'actions',
            Cell: ({ row }) => (
                <div className="d-flex justify-content-center">
                    <button className="btn btn-sm btn-danger mx-1" title="Delete" onClick={() => handleDelete(row.original.id)}>
                        <FaTrash />
                    </button>
                </div>
            )
        }
    ];

    useEffect(() => {
        fetchFiles();
    }, []);

    return (
        <div className="container-fluid mt-4">
            <div className="dashboard-header-card d-flex align-items-center justify-content-between mb-4 mx-2 shadow-lg" style={{ background: 'linear-gradient(135deg, #0054A6 0%, #007BFF 100%)', borderRadius: '15px', padding: '1.5rem 2rem' }}>
                <div className="d-flex align-items-center">
                    <div className="icon-circle mr-3" style={{ background: 'rgba(255,255,255,0.2)', width: '50px', height: '50px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <i className="fa fa-file-pdf text-white" style={{ fontSize: '24px' }}></i>
                    </div>
                    <div>
                        <h3 className="text-white font-weight-bold mb-0" style={{ letterSpacing: '0.5px' }}>Event Files</h3>
                        <p className="text-white-50 mb-0 small">Manage uploaded PDFs for events</p>
                    </div>
                </div>
                <div>
                    <Link to="/events/files/add" className="btn btn-light font-weight-bold shadow-sm" style={{ borderRadius: '8px', padding: '0.6rem 1.2rem', color: '#0054A6' }}>
                        <i className="fa fa-plus mr-2"></i>
                        Upload PDF
                    </Link>
                </div>
            </div>

            {loading ? (
                <div className="text-center my-5">
                    <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            ) : (
                <div className="mx-2">
                    <AdminTable tableHeaders={tableHeaders} tableData={files} />
                </div>
            )}
        </div>
    );
};

export default ListEventFiles;
